// extracted by mini-css-extract-plugin
export default {"root":"rl_Bq","transform":"_39fVP","swipeable":"_1leom","preview":"_2b1D9","next":"_3zB4o","prev":"geBd_"};